import { string, object } from "yup";

export const emailSchema = string().email("Invalid email").required("Email is required");
export const passwordSchema = string().required("Password is required");

export const loginSchema = object( {
    email: emailSchema,
    password: passwordSchema
} )